import React from 'react'
import styled from 'styled-components'
import { Colors, Modal } from 'advenio-components'

const HeaderSpan = styled.div`
  color: ${Colors.gray700};
  font-size: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  background-color: ${Colors.yellow300};
  padding-bottom: 15px;
  padding-top: 15px;
`

const MsgContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 32px 15px 32px;
`
const MsgText = styled.p`
  color: ${Colors.gray700};
  margin-bottom: 16px;
`

const ModalSupport = ({ show, message }) => <Modal
    isOpened={ show }
    // onClose={this.onCloseSupport}
    //headerTitle={'Mantenimiento'}
    >
    <HeaderSpan>
        <img src={'/assets/Warning.svg'} style={{ paddingRight: '5px' }} />
        <span>Aviso - Mantenimiento</span>
    </HeaderSpan>
    <MsgContainer>
      <MsgText>
        {message}
        {/* Le informamos que hoy 25 de julio, los servicios de Advenio quedaran fuera por mantenimiento en un horario de 9:00 pm a 10:30 pm (UTC). */}
        <br />
        <br />
        Agradecemos su atención y comprensión.
      </MsgText>
    </MsgContainer>
  </Modal>

export default ModalSupport



// WEBPACK FOOTER //
// ./src/shared/ModalSupport.jsx